import { render, staticRenderFns } from "./RevisionEntriesList.vue?vue&type=template&id=8b1d6a1c&scoped=true"
import script from "./RevisionEntriesList.vue?vue&type=script&lang=js"
export * from "./RevisionEntriesList.vue?vue&type=script&lang=js"
import style0 from "./RevisionEntriesList.vue?vue&type=style&index=0&id=8b1d6a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1d6a1c",
  null
  
)

export default component.exports